(function () {
  'use strict';

  angular.module('ringbaPortal').component('brp', {
    bindings: {
      brpDetails: '<'
    },
    controller: BrpController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/auth/v2/brp.view.html'
  });

  function BrpController(
    $stateParams,
    cacheService,
    whitelabelService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    function onInit() {
      _checkPreviewMode();
      vm.isWhitelabeledSite = !whitelabelService.checkLocationHostIsBase() || $stateParams.preview == 'true';
      vm.brpId = $stateParams.brpId;
    }

    function _checkPreviewMode() {
      if ($stateParams.preview) {
        vm.previewModeEnabled = true;
        vm.currentTheme = cacheService.get('brp-register-preview');
        vm.isLightTheme = vm.currentTheme && vm.currentTheme.isLightTheme;
        cacheService.remove('brp-register-preview');
      }
    }
  }
})();
